import * as Sentry from '@sentry/astro';

Sentry.init({
	dsn: 'https://e7e9e2d8467dbc71fe214afd7e5c6a1d@o342255.ingest.us.sentry.io/4510716700327936',

	// HIPAA Compliance Settings
	// -------------------------

	// CRITICAL: Disable sending PII by default (IP addresses, user agents, etc.)
	sendDefaultPii: false,

	// Don't attach stack traces to messages (could contain PHI in variable values)
	attachStacktrace: false,

	// Limit breadcrumbs to reduce PHI exposure surface
	maxBreadcrumbs: 20,

	// Scrub potential PHI from error events before sending
	beforeSend(event, hint) {
		// Scrub user data that might contain PHI
		if (event.user) {
			delete event.user.email;
			delete event.user.username;
			delete event.user.ip_address;
		}

		// Scrub request data that might contain PHI (URLs, headers, body)
		if (event.request) {
			delete event.request.cookies;
			delete event.request.data; // POST body data
			// Scrub query strings from URLs (may contain patient identifiers)
			if (event.request.url) {
				event.request.url = event.request.url.split('?')[0];
			}
			if (event.request.query_string) {
				delete event.request.query_string;
			}
		}

		return event;
	},

	// Filter breadcrumbs to prevent PHI capture
	beforeBreadcrumb(breadcrumb, hint) {
		// Drop console breadcrumbs entirely (may contain logged PHI)
		if (breadcrumb.category === 'console') {
			return null;
		}

		// Scrub URLs in navigation breadcrumbs
		if (breadcrumb.category === 'navigation') {
			if (breadcrumb.data?.to) {
				breadcrumb.data.to = breadcrumb.data.to.split('?')[0];
			}
			if (breadcrumb.data?.from) {
				breadcrumb.data.from = breadcrumb.data.from.split('?')[0];
			}
		}

		// Scrub fetch/xhr URLs
		if (breadcrumb.category === 'fetch' || breadcrumb.category === 'xhr') {
			if (breadcrumb.data?.url) {
				breadcrumb.data.url = breadcrumb.data.url.split('?')[0];
			}
		}

		return breadcrumb;
	},
});
